import _ from 'lodash';

const TableMixin = {
  methods: {
    async update(options) {
      if (_.isFunction(this.setTableOptions)) this.setTableOptions(options);
      this.limit = options.itemsPerPage;
      this.skip = options.itemsPerPage * (options.page - 1);
      this.sort = this.getSortFromOptions(options);
      await this.load();
    },
    getSortFromOptions(options) {
      if (!options.sortBy || !options.sortBy.length) return this.defaultSort;
      const sort = {};
      for (let i = 0; i < options.sortBy.length; ++i) {
        const key = options.sortBy[i];
        const desc = options.sortDesc[i];

        if (this.headers) {
          const head = this.headers.find((h) => h.value === key);
          if (head.size) {
            sort[head.size] = desc ? -1 : 1;
            return sort;
          }
        }
        sort[key] = desc ? -1 : 1;
      }
      return sort;
    }
  }
};
export default TableMixin;
